import React from 'react'
import { Link } from 'react-router-dom'


function SimilarProject() {
  return (
    <>
      <section className="similar-project">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Similar projects</span>
            </div>
            <h2 className="section-title__title">
              Recently Completed Our
              <br /> Clients <span>Projects</span>
            </h2>
          </div>
          <div className="row">

            <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
              <div className="project-two__single">
                <div className="project-two__img-box">
                  <div className="project-two__img">
                    <img src="assets/images/project/project-2-4.jpg" alt="" />
                  </div>
                  <div className="project-two__tagline">
                    <p>Consulting</p>
                  </div>
                </div>
                <div className="project-two__title-box">
                  <h3 className="project-two__title">
                    <Link to="/porfolio-details">Data Analysis</Link>
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
              <div className="project-two__single">
                <div className="project-two__img-box">
                  <div className="project-two__img">
                    <img src="assets/images/project/project-2-5.jpg" alt="" />
                  </div>
                  <div className="project-two__tagline">
                    <p>Consulting</p>
                  </div>
                </div>
                <div className="project-two__title-box">
                  <h3 className="project-two__title">
                    <Link to="/porfolio-details">Market Rules</Link>
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
              <div className="project-two__single">
                <div className="project-two__img-box">
                  <div className="project-two__img">
                    <img src="assets/images/project/project-2-6.jpg" alt="" />
                  </div>
                  <div className="project-two__tagline">
                    <p>Consulting</p>
                  </div>
                </div>
                <div className="project-two__title-box">
                  <h3 className="project-two__title">
                    <Link to="/porfolio-details">Pure Consulting</Link>
                  </h3>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default SimilarProject
